import type { ReactNode } from 'react';

import { Card, CardContent, CardHeader } from '@/components/ui/card';
import cn from '@/utils/cn';

interface SectionCardProps {
  title: string;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
  contentClassName?: string;
}

export function SectionCard({
  title,
  action,
  children,
  className,
  contentClassName,
}: SectionCardProps) {
  return (
    <Card padding="none" className={cn('border-border/70 shadow-none', className)}>
      <CardHeader className="flex flex-col items-start gap-2 space-y-0 p-4 pb-3 sm:flex-row sm:items-center sm:justify-between sm:gap-0 sm:p-6 sm:pb-3">
        {/* A real <h2>: CardTitle renders a plain <div>, so every section title
            on the dashboard was invisible to heading navigation. */}
        <h2 className="min-w-0 text-base font-bold tracking-tight">{title}</h2>
        {action}
      </CardHeader>
      <CardContent className={cn('p-4 pt-0 sm:p-6 sm:pt-0', contentClassName)}>
        {children}
      </CardContent>
    </Card>
  );
}
